module.exports = __webpack_public_path__ + "img/pop-right.226d26e9.png";